// src/core/profile.ts
import type { ChannelErrors } from '../types';

export type ProfileResult = {
  meanHue: number;
  meanSat: number;
  meanLight: number;
  weakest: 'hue' | 'sat' | 'light';
  strongest: 'hue' | 'sat' | 'light';
};

export function profile(errSum: ChannelErrors, count: number): ProfileResult | null {
  if (count <= 0) return null;
  const meanHue = errSum.hue / count;
  const meanSat = errSum.sat / count;
  const meanLight = errSum.light / count;

  // Normalize to "fraction of channel range" so we can compare apples-to-apples.
  // Hue: 0–180 (circular). Sat/Light: 0–100.
  const channels = [
    { name: 'hue' as const, norm: meanHue / 180 },
    { name: 'sat' as const, norm: meanSat / 100 },
    { name: 'light' as const, norm: meanLight / 100 },
  ];
  channels.sort((a, b) => a.norm - b.norm);
  return {
    meanHue,
    meanSat,
    meanLight,
    strongest: channels[0].name, // lowest normalized error
    weakest: channels[2].name,   // highest normalized error
  };
}
